/**
 * RidesBookingsService
 * Rider bookings: create, mine, detail, cancel, dispute.
 * Route: rides/api/rides/bookings
 */
import { BaseService } from '../base/BaseService';
import { unwrapRidesResponse as unwrap } from './unwrapRidesResponse';
/** Bookings service (JWT; booker must be verified — guardian-verified when forMinor). */
export class RidesBookingsService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? RidesBookingsService.DEFAULT_SERVICE_PATH,
            basePath: RidesBookingsService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /** POST api/rides/bookings — seats are taken atomically; 409 `seats_unavailable` when the listing filled. */
    async create(request) {
        return unwrap(await this.createRaw(request), 'Failed to create booking');
    }
    createRaw(request) {
        return this.http.post(this.buildUrl(), request);
    }
    /** GET api/rides/bookings/mine */
    async getMine() {
        return (await this.getMineRaw()).data ?? [];
    }
    getMineRaw() {
        return this.http.get(this.buildUrl('mine'));
    }
    /** GET api/rides/bookings/{id} */
    async getById(id) {
        return unwrap(await this.getByIdRaw(id), `Booking ${id} not found`);
    }
    getByIdRaw(id) {
        return this.http.get(this.buildUrl(String(id)));
    }
    /** POST api/rides/bookings/{id}/cancel — releases the seats (notifies the driver). */
    async cancel(id, request = {}) {
        return unwrap(await this.cancelRaw(id, request), `Failed to cancel booking ${id}`);
    }
    cancelRaw(id, request = {}) {
        return this.http.post(this.buildUrl(`${id}/cancel`), request);
    }
    /** POST api/rides/bookings/{id}/dispute — raise a dispute on the booking. */
    async dispute(id, request) {
        return unwrap(await this.disputeRaw(id, request), `Failed to raise a dispute on booking ${id}`);
    }
    disputeRaw(id, request) {
        return this.http.post(this.buildUrl(`${id}/dispute`), request);
    }
}
RidesBookingsService.DEFAULT_SERVICE_PATH = 'rides';
RidesBookingsService.BASE_PATH = 'api/rides/bookings';
//# sourceMappingURL=RidesBookingsService.js.map